@if (item) {
  <a
    appActiveRoute
    appUnsavedFormCheck
    class="nav-link d-flex flex-md-column justify-content-lg-start align-items-center nav-link-route"
    [href]="item.route ? item.route : '#'"
    [ngClass]="{ 'dropdown-hover__trigger': item.subMenus }"
    [ngClass]="wrapperClass"
    (click)="launchLoadingIndicator($event, item.route ? item.route : '#')"
    (unsavedForm)="handleUnsavedFormState($event)"
  >
    <span
      class="nav-item__icon-container position-relative"
      [ngClass]="{
        'py-1': item.jipIcon && item.isSharedIcon,
      }"
      [style.height.px]="!item.isSharedIcon ? 24 : 'auto'"
    >
      @if (item.jipIcon && item.isSharedIcon) {
        <app-shared-icon
          [name]="item.jipIcon"
          [hasBigSize]="true"
        ></app-shared-icon>
      }
      @if (item.ngIcon) {
        <ng-icon
          class="nav__item-icon"
          [name]="item.ngIcon"
          size="1.5rem"
        ></ng-icon>
      }
      @if (item.jipIcon && !item.isSharedIcon) {
        <app-internal-icon
          [name]="item.jipIcon"
          [height]="24"
        >
        </app-internal-icon>
      }
      @if (!!count) {
        <span class="news__badge"></span>
      }
    </span>
    <span
      [style.min-width.px]="item.minWidth || 'unset'"
      class="py-1 font-size-sm truncate-line-1"
    >
      {{ item.name | translate }}
    </span>
  </a>
}
